import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const initialState = {
    params: {
	    pageNum: 1,
	    pageSize: 10,
	    type: '0', // 消息类型
	    status: '' // 消息状态
    },
    message: { // 消息列表
        unReadCount: {},
        total: 0,
	    list: []
    }
}

const reducers = createActions({
    updateUnRead: (state, action) => {
        const { params: { type }, message: { unReadCount = {}, list = [] } } = state
	    const li = list.map(item => {
            if (item.messageId === action.payload) return { ...item, status: 1 }
            return item
	    })
	    const count = unReadCount[type] || 0
	    return {
            ...state,
		    message: {
                ...state.message,
			    list: li,
			    unReadCount: { ...unReadCount, [type]: count > 0 ? count - 1 : 0 }
		    }
	    }
    },
    queryUserOrderMessageAction: {
        pending: (state, action) => {
            const { pageNum, type, status } = action.meta.arg
            return { ...state, params: { ...state.params, pageNum, type, status } }
        },
        success: (state, action) => {
            const { total, list = [], unreadCountList = [] } = action.payload
	        const unReadCount = unreadCountList.reduce((obj, cur) => ({ ...obj, [cur.type]: cur.unreadCount }), {})
	        return { ...state, message: { total, list, unReadCount } }
        }
    }
}, actions)

const serverMessageSlice = createSlice({
    name: 'serverMessage',
    initialState,
    ...reducers
})

export const {
    updateUnRead
} = serverMessageSlice.actions

export default serverMessageSlice
